import { filter, map, Observable, Subject } from 'rxjs';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

export abstract class DialogOutletService {
  private entityId$ = new Subject<string | null>();
  protected constructor(protected router: Router, private outlet: string) {}

  public onCloseModal(): void {
    this.entityId$.next(null);
  }

  public onOpenModal(id: string): void {
    this.entityId$.next(id);
  }

  public getOutletStatus$(): Observable<string | null> {
    return this.entityId$.pipe(
      filter(id => id !== ''),
      map(id => (id ? id : null))
    );
  }

  public outletNavigation(
    activatedRoute: ActivatedRoute,
    outletStatus: string | null,
    url = './',
    skipLocationChange = false,
    state: { [key: string]: string } | null = null
  ): void {
    const outlet = outletStatus === null ? outletStatus : [outletStatus];
    let extras: NavigationExtras = {
      queryParamsHandling: 'preserve',
      relativeTo: activatedRoute,
      skipLocationChange,
    };

    if (!!state) {
      extras.state = state;
    }

    this.router.navigate([url, { outlets: { [this.outlet]: outlet } }], extras);
  }
}
